import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/img/logo_icon.svg'
import _imports_1 from '@/img/close.svg'


const _hoisted_1 = { class: "opModal p-3 text-center position-relative" }
const _hoisted_2 = { class: "d-flex justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = { class: "closeButton" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "midTitle mt-4" }
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "control-label" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "control-label" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "control-label" }
const _hoisted_15 = { class: "mt-5" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_6)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_localized_text, {
        localizedKey: "Inserisci i dati per il calcolo",
        text: "Inserisci i dati per il calcolo"
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("label", _hoisted_10, [
          _createVNode(_component_localized_text, {
            localizedKey: "Quanti anni di fumo",
            text: "Quanti anni di fumo"
          })
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.anniFumo) = $event))
        }, null, 512), [
          [_vModelText, _ctx.anniFumo]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("label", _hoisted_12, [
          _createVNode(_component_localized_text, {
            localizedKey: "Quante sigarette al giorno",
            text: "Quante sigarette al giorno"
          })
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vm.quanteSigaretteAlGiorno) = $event))
        }, null, 512), [
          [_vModelText, _ctx.vm.quanteSigaretteAlGiorno]
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("label", _hoisted_14, [
          _createVNode(_component_localized_text, {
            localizedKey: "Costo di un pacchetto",
            text: "Costo di un pacchetto"
          })
        ]),
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vm.prezzoPacchettoSigarette) = $event))
        }, null, 512), [
          [_vModelText, _ctx.vm.prezzoPacchettoSigarette]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: !_ctx.can,
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "Calcola",
          text: "Calcola"
        })
      ], 8, _hoisted_16)
    ])
  ]))
}